<template>
    <router-view :main="main"
                 :key="$route.query"
    ></router-view>
</template>

<script>

import {useHead} from "@vueuse/head";

export default {
    name: "app",
    components: {
    },
    inject: ['auth'],
    data() {
        return {
            // currentLocale: '',
            main: [],
        }
    },
    async created() {
        await this.getMain();

    },
    watch: {
        '$route': function (newVal) {
            useHead({
                title: this.main?.settings?.name,
            })
        },
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        async getMain() {
            await axios.get('main').then(response => {
                // toast.success("content loading...", {
                //     timeout: 2000
                // });
                this.main = response.data?.data;
                // this.currentLocale = response.data?.data?.lang;
                // this.$i18n.locale = this.currentLocale;
                // console.log(this.currentLocale);

            });
        },
    },
}
</script>
